export default __webpack_public_path__ + "static/media/sport_4.ac40c494.png";